import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay/legacy';
import { getFilterValues } from '../sbSharedRefineMenuHelpers';

// components
import { SbSharedRefineMenuMultiSelect } from '../SbSharedRefineMenuMultiSelect/SbSharedRefineMenuMultiSelect';
import { SbSharedRefineMenuExpandableItemList } from '../SbSharedRefineMenuExpandableItemList/SbSharedRefineMenuExpandableItemList';

/* eslint-disable react/prop-types */

export const SbSharedRefineMenuMultiSelectListComponent = props => {
    const { values, itemSearch, filterName, collapsedItemCount, shouldUseExpandableList } = props;
    const { appliedFilters } = itemSearch;

    const appliedFilterValues = getFilterValues(appliedFilters, filterName);

    if (!shouldUseExpandableList) {
        // skip the expandable list
        return (
            <SbSharedRefineMenuMultiSelect
                filterName={filterName}
                appliedFilterValues={appliedFilterValues}
                valuesToShow={values}
            />
        );
    }

    return (
        <SbSharedRefineMenuExpandableItemList
            filterName={filterName}
            availableFilterValues={values}
            collapsedItemCount={collapsedItemCount}
        >
            {({ valuesToShow }) => (
                <SbSharedRefineMenuMultiSelect
                    filterName={filterName}
                    appliedFilterValues={appliedFilterValues}
                    valuesToShow={valuesToShow}
                />
            )}
        </SbSharedRefineMenuExpandableItemList>
    );
};

SbSharedRefineMenuMultiSelectListComponent.propTypes = {
    values: PropTypes.array.isRequired,
    collapsedItemCount: PropTypes.number,
    filterName: PropTypes.string.isRequired,
    itemSearch: PropTypes.object.isRequired,
    shouldUseExpandableList: PropTypes.bool,
};

SbSharedRefineMenuMultiSelectListComponent.defaultProps = {
    shouldUseExpandableList: true,
};

export const SbSharedRefineMenuMultiSelectList = createFragmentContainer(
    SbSharedRefineMenuMultiSelectListComponent,
    {
        itemSearch: graphql`
            fragment SbSharedRefineMenuMultiSelectList_itemSearch on ItemSearchQueryConnection {
                appliedFilters {
                    name
                    localizedFilterName
                    canBeDismissed
                    values {
                        urlLabel
                        count
                        displayName
                    }
                }
            }
        `,
    }
);
